import { abandonstate, staffListSelect, getCreateVoucherCode } from '@/utils/api'
import moment from 'moment';
export const method = {
    data() {
        return {
            agentList: [],
            isEvent: false,
            buttonList: [],
            attachmentResourceIdList: [],
            attachmentResourceList: [],
            typeindex: '',
        }
    },
    mounted() {
        for (let i = 0; i < 18; i++) {
            this.dataSource.push({
                isCheck1: false,
                isCheck2: false,
                isCheck3: false,
                isCheck4: false
            })
        }
        this.form = this.$form.createForm(this)
        if (!this.$route.query.id) {
            this.$nextTick(() => {
                document.getElementById('contactCustomerName').focus()
            })
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (!this.isEmpty(to.query.id)) {
            this.detailId = to.query.id
            this.typeindex = to.query.type
            if (to.query.type == 1) {
                this.buttonList = [
                    {
                        id: 3,
                        text: '再次申请'
                    },
                    {
                        id: 19,
                        text: '废弃'
                    }
                ]
            }
            this.getWatchInfo()
            next()
        }
    },
    watch: {

    },
    activated() {
        this.agentListSelect()
        this.detailId = this.$route.query.id
        this.typeindex = this.$route.query.type
        if (this.isEmpty(this.detailId)) {
            return;
        }
        if (this.$route.query.type == 1) {
            this.buttonList = [
                {
                    id: 3,
                    text: '再次申请'
                },
                {
                    id: 19,
                    text: '废弃'
                }
            ]
        }
        this.getWatchInfo()
    },
    methods: {
        moment,
        /**
         * @description: 经办人下拉框  员工（方法描述）
         */
        agentListSelect() {
            let data = {
                companyStoreId: this.$store.state.shopId
            }
            data = this.$qs.stringify(data)
            staffListSelect(data, {}).then((res) => {
                if (res.success) {
                    this.agentList = res.result
                    let transactorNameData = JSON.parse(localStorage.getItem('transactorName'))
                    if (transactorNameData && !this.$route.query.id) {
                        this.$nextTick(() => {
                            this.form.setFieldsValue({
                                transactorId: transactorNameData.transactorId
                            })
                        })
                    }
                }
            })
        },

        handleChangeTransact(value) {
            let name = ''
            this.agentList.forEach((item) => {
                if (item.id == value) {
                    name = item.name
                }
            })
            localStorage.setItem('transactorName', JSON.stringify({
                transactorId: value,
                transactorName: name
            }))
        },
        /**
         * @description: tab添加一行（方法描述）
         */
        onAddDatesource() {
            this.dataSource.push({
                isCheck1: false,
                isCheck2: false,
                isCheck3: false,
                isCheck4: false,
            })
        },
        /**
        * @description: 往来单位（方法描述）
        */
        pressEnterContact() {
            //  if(!this.isEvent){
            let contactCustomerName = ''
            this.form.validateFields((err, values) => {
                if (!err) {
                    contactCustomerName = values.contactCustomerName
                }
            })
            this.$refs.receiptModel.onOpen(contactCustomerName, this.contactCustomerId)
            //  }
        },
        /**
         * @description: 往来单位（方法描述）
         */
        pressEnterContact1() {
            let contactCustomerName = ''
            this.form.validateFields((err, values) => {
                if (!err) {
                    contactCustomerName = values.contactCustomerName
                }
            })
            this.$refs.receiptModel.onOpen(contactCustomerName, this.contactCustomerId)
        },
        /**
         * @description: tab点击出现输入框（方法描述）
         */
        onClickTab(record, index) {
            this.closeIconBlock()
            if (index == 3) {
                record.isCheck3 = true
            } else if (index == 4) {
                record.isCheck4 = true
            }
        },
        /**
         * @description: 数字输入框（方法描述）
         */
        changeNumber(value, record) {
            record.amount = value
            this.tableAddTotalRow(this.columns, this.dataSource)
        },
        /**
         * @description: 时间选择器（方法描述）
         */
        changeDate(date, dateString) {
            this.dataTime = dateString
        },
        /**
         * @description:出现输入框（方法描述）
         */
        onClickShop(record, index) {
            this.closeIconBlock()
            clearTimeout(this.timeoutID)
            this.timeoutID = window.setTimeout(() => {
                if (index == 1) {
                    record.isCheck1 = true
                } else {
                    record.isCheck2 = true
                }
            }, 300)
        },
        /**
         * @description: 删除（方法描述）
         */
        btnDeleteMenu(index) {
            this.$comm.removeByIndex(this.dataSource, index)
            this.tableAddTotalRow(this.columns, this.dataSource)
        },
        // 上传附件
        onChangeFile(data) {
            this.attachmentResourceIdList = []
            data.map(item => {
                this.attachmentResourceIdList.push(item.id)
            })
        },
        onPressenter(record, index, index1) {
            if (index == 1) {
                record.isCheck3 = false
                this.dataSource[index1 + 1].isCheck1 = true
            } else if (index == 2) {
                record.isCheck4 = false
            } else if (index == 3) {
                record.isCheck1 = false
                this.dataSource1[index1 + 1].isCheck1 = true
            }
        },
        //打印的四个按钮回调
        onCancelPrint() {
            if (this.isEmpty(this.detailId)) {
                this.getVocherCode()
            } else {
                this.$store.state.closePath = this.$route.fullPath
            }
        },
        onDeleteOrder(record, index) {
            let data = new FormData()
            data.append('companyStoreId', this.$store.state.shopId)
            data.append('voucherEntityId', this.detailId)
            abandonstate(data, {}, {}).then((res) => {
                if (res.success) {
                    this.$store.state.closePath = this.$route.fullPath
                    this.$message.success(res.logMessage)
                } else {
                    this.$message.warn(res.logMessage)
                }
            })
        },
        // 选择收款账户
        btnSelectAccount() {
            this.$refs.accountPopover.show()
        },
        // 选择账户回调
        btnSelectCategory(data) {
            this.formData.nowPaymentAmount = undefined
            this.formData.financeOtherIncomeCollectionAccountVOList = [{
                financeAccountId: data.id,
                financeAccountName: data.name
            }]
            this.nowPaymentAmountdisabled = false
            this.formData.amountName = data.name
            this.$refs.inputMoney.focus()
        },
        // 输入金额
        btnEnterAmount(e) {
            this.formData.financeOtherIncomeCollectionAccountVOList[0].amount = e.target.value
            this.formData.nowPaymentAmount = e.target.value
        },
        // 选择多账户回调
        btnSelectAccounts(paymentAccountVOList, nowPaymentAmount) {
            this.formData.financeOtherIncomeCollectionAccountVOList = paymentAccountVOList
            this.formData.amountName = '多账户'
            this.nowPaymentAmountdisabled = true
            this.formData.nowPaymentAmount = nowPaymentAmount
        },
        //获取code index 1为其他支出  2 其他收入单  3付款单  4收款单
        getVocherCode(voucherType, index) {
            this.dataSource = []
            for (let i = 0; i < 18; i++) {
                this.dataSource.push({
                    isCheck1: false,
                    isCheck2: false,
                    isCheck3: false,
                    isCheck4: false,
                })
            }
            if (index == 3 || index == 4) {
                this.tableHeight = this.tableHeights
                this.tabIndex = 1
            }
            let data = new FormData()
            data.append('voucherType', voucherType)
            data.append('companyStoreId', this.$store.state.shopId)
            getCreateVoucherCode(data, {}).then((res) => {
                if (res.success) {
                    if (index == 1 || index == 2) {
                        this.form = this.$form.createForm(this)
                        this.formData.discounts = ''
                        this.formData.amountName = ''
                        this.formData.nowPaymentAmount = ''
                        this.formData.collectionTotalAmount = 0.00
                        this.formData.financeOtherIncomeCollectionAccountVOList = []
                        this.contactCustomerId = ''
                    }
                    if (index == 3 || index == 4) {
                        this.form = this.$form.createForm(this)
                        this.attachmentResourceList = []
                        this.attachmentResourceIdList = []
                        this.contactCustomerId = ''
                        this.numData.payableBalance = 0.00
                        this.numData.receivableAmount = 0.00
                        this.numData.totalAmount = 0.00
                        this.numData.discountAmount = ''
                    }
                    if (index == 1) {
                        this.$nextTick(() => {
                            let transactorNameData = JSON.parse(localStorage.getItem('transactorName'))
                            if (this.isEmpty(transactorNameData)) {
                                this.form.setFieldsValue({
                                    expenditureCode: res.result,
                                })
                            } else {
                                this.form.setFieldsValue({
                                    expenditureCode: res.result,
                                    transactorId: transactorNameData.transactorId
                                })
                            }
                            this.form.setFieldsValue({ expenditureDate: new Date().toLocaleDateString() ? moment(new Date().toLocaleDateString()) : null })
                        });
                    } else if (index == 2) {
                        this.$nextTick(() => {
                            let transactorNameData = JSON.parse(localStorage.getItem('transactorName'))
                            if (this.isEmpty(transactorNameData)) {
                                this.form.setFieldsValue({
                                    code: res.result,
                                })
                            } else {
                                this.form.setFieldsValue({
                                    code: res.result,
                                    transactorId: transactorNameData.transactorId
                                })
                            }
                            this.form.setFieldsValue({ voucherDate: new Date().toLocaleDateString() ? moment(new Date().toLocaleDateString()) : null })
                        });
                    } else if (index == 3) {
                        this.$nextTick(() => {
                            let transactorNameData = JSON.parse(localStorage.getItem('transactorName'))
                            if (this.isEmpty(transactorNameData)) {
                                this.form.setFieldsValue({
                                    code: res.result,
                                })
                            } else {
                                this.form.setFieldsValue({
                                    code: res.result,
                                    transactorId: transactorNameData.transactorId
                                })
                            }
                            this.form.setFieldsValue({ orderDate: new Date().toLocaleDateString() ? moment(new Date().toLocaleDateString()) : null })
                        });
                    } else if (index == 4) {
                        this.$nextTick(() => {
                            let transactorNameData = JSON.parse(localStorage.getItem('transactorName'))
                            if (this.isEmpty(transactorNameData)) {
                                this.form.setFieldsValue({
                                    code: res.result,
                                })
                            } else {
                                this.form.setFieldsValue({
                                    code: res.result,
                                    transactorId: transactorNameData.transactorId
                                })
                            }
                            this.form.setFieldsValue({ voucherDate: new Date().toLocaleDateString() ? moment(new Date().toLocaleDateString()) : null })
                        });
                    }
                    this.tableAddTotalRow(this.columns, this.dataSource)
                }
            })
            this.getButtonEdit(index)
        },
        //再次获取code index 1为其他支出  2
        getVocherCodeTwo(voucherType, index) {
            let data = new FormData()
            data.append('voucherType', voucherType)
            data.append('companyStoreId', this.$store.state.shopId)
            getCreateVoucherCode(data, {}).then((res) => {
                if (res.success) {
                    this.$nextTick(() => {
                        if (index == 1) {
                            this.form.setFieldsValue({
                                expenditureCode: res.result
                            })
                        } else if (index == 2) {
                            this.form.setFieldsValue({
                                code: res.result,
                            })
                        } else if (index == 3) {
                            this.form.setFieldsValue({
                                code: res.result
                            })
                        } else if (index == 4) {
                            this.form.setFieldsValue({
                                code: res.result
                            })
                        }

                    });
                    this.$message.success('单据编号已存在，系统已为您重新分配编号，请重新提交')
                }
            })
        },
        closeIconBlock() {
            this.dataSource.forEach((item) => {
                item.isCheck1 = false
                item.isCheck2 = false
                item.isCheck3 = false
                item.isCheck4 = false
            })
        },
        //buttonlist index 1为其他支出  2 其他收入单  3付款单  4收款单    
        getButtonEdit(index) {
            if (index == 1) {
                this.buttonList = [
                    {
                        id: 1,
                        text: '取消退出'
                    },
                    {
                        id: 2,
                        text: '存为草稿',
                        has: 'finance_other_expenses_draft_save',
                    }, {
                        id: 3,
                        text: '提交过账',
                        class: 'ant-btn-primary',
                        has: 'finance_other_expenses_new_post',
                    },
                ]
            } else if (index == 2) {
                this.buttonList = [
                    {
                        id: 1,
                        text: '取消退出'
                    },
                    {
                        id: 2,
                        text: '存为草稿',
                        has: 'finance_other_revenue_draft_save',
                    }, {
                        id: 3,
                        text: '提交过账',
                        class: 'ant-btn-primary',
                        has: 'finance_other_revenue_new_post',
                    },
                ]
            } else if (index == 3) {
                this.buttonList = [
                    {
                        id: 1,
                        text: '取消退出'
                    },
                    {
                        id: 2,
                        text: '存为草稿',
                        has: 'finance_payment_draft_save',
                    }, {
                        id: 3,
                        text: '提交过账',
                        class: 'ant-btn-primary',
                        has: 'finance_payment_new_post',
                    },
                ]
            } else if (index == 4) {
                this.buttonList = [
                    {
                        id: 1,
                        text: '取消退出'
                    },
                    {
                        id: 2,
                        text: '存为草稿',
                        has: 'finance_receipt_draft_save',
                    }, {
                        id: 3,
                        text: '提交过账',
                        class: 'ant-btn-primary',
                        has: 'finance_receipt_new_post',
                    },
                ]
            }
        },


        /**
         * @description: 获取当前时间（方法描述）
         */
        getTime() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month < 10) {
                month = "0" + month;
            }
            if (day < 10) {
                day = "0" + day;
            }
            return year + "-" + month + "-" + day
        },

        btnkeydown() {
            let i = 0
            this.dataSource.forEach((item) => {
                if (!this.isEmpty(item.financeAccountCode)) {
                    i++
                }
            })
            this.dataSource[i].isCheck1 = true
        },
        /**
         * @description: 强制保留两位小数（方法描述）
         */
        toDecimal(value) {
            var value = Math.round(parseFloat(value) * 100) / 100;
            var xsd = value.toString().split(".");
            if (xsd.length == 1) {
                value = value.toString() + ".00";
                return value;
            }
            if (xsd.length > 1) {
                if (xsd[1].length < 2) {
                    value = value.toString() + "0";
                }
                return value;
            }
        },
    },
}
